import { z } from "zod";

export const ResourceAccessSchema = z.object({
  isOwner: z.boolean(),
  canUse: z.boolean(),
  canEdit: z.boolean(),
  canDelete: z.boolean(),
  canManageShares: z.boolean(),
});

export type ResourceAccess = z.infer<typeof ResourceAccessSchema>;
